/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TestERC1155, TestERC1155Interface } from "../TestERC1155";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [],
    name: "CASTLE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FARM",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MILL",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VILLAGE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintCastle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintFarm",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintMill",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintMine",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintVillage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type TestERC1155ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestERC1155ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestERC1155__factory extends ContractFactory {
  constructor(...args: TestERC1155ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "TestERC1155";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TestERC1155> {
    return super.deploy(overrides || {}) as Promise<TestERC1155>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): TestERC1155 {
    return super.attach(address) as TestERC1155;
  }
  connect(signer: Signer): TestERC1155__factory {
    return super.connect(signer) as TestERC1155__factory;
  }
  static readonly contractName: "TestERC1155";
  public readonly contractName: "TestERC1155";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestERC1155Interface {
    return new utils.Interface(_abi) as TestERC1155Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestERC1155 {
    return new Contract(address, _abi, signerOrProvider) as TestERC1155;
  }
}
